import { AuthRoutes } from '@vs/oidc-client';
import { toggleSessionExpired } from '@vs/rtk/slices/genericGlobal';
import { PortalBackdrop } from '@vs/ui/portal/backdrop';

import { useAppDispatch } from '../../redux/hooks';
import AppContentInit from './AppContentInit';

export default function AppAuthRoutes() {
  const dispatch = useAppDispatch();

  function showSessionExpired() {
    dispatch(toggleSessionExpired(true));
  }

  return (
    <AuthRoutes
      renderLoadingUI={() => <PortalBackdrop type="app_init" open />}
      renderComponent={() => <AppContentInit />}
      propsAuthGuard={{
        extraQueryParams: {
          sso: 'microsoft',
        },
        onTokenRefreshError: showSessionExpired,
        onLogout: showSessionExpired,
      }}
    />
  );
}
